import Component from './DeviceGroups.vue';

export default Component;
